export default __webpack_public_path__ + "static/media/logomark1.aecee866.jpeg";